import { SaveInvoiceParams } from 'lib/api/invoice';
import { InvoiceDetailProps } from './InvoiceDetail';
import { createSelector } from 'reselect';

const getContainerId = ({ containerId }: InvoiceDetailProps) => containerId;

const getInvoice = ({ invoice }: InvoiceDetailProps) => invoice;

const getSupplierResult = ({ SupplierResult }: InvoiceDetailProps) => SupplierResult;

export type FormValues = SaveInvoiceParams;

export const deriveFormValues = createSelector(
  getContainerId,
  getInvoice,
  getSupplierResult,
  (containerId, invoice): FormValues => ({
    ContainerId: containerId,
    Invoice: {
      InvoiceId: invoice.InvoiceId,
      Pages: invoice.Pages.map(({ PageNo }) => ({ PageNo })),
      DetectInvoiceResponse: invoice.DetectInvoiceResponse,
      SupplierResult: invoice.SupplierResult,
    },
    BadClientId: invoice.BadClientId,
    BadSupplierId: invoice.BadSupplierId,
  }),
);
